import {createBrowserHistory, createHashHistory} from 'history'

const usesHtmlFile = /\.html/.test(window.location.pathname)

// FIXME: Singletons are kind of worrisome - this here is created without any usage just by importing the library.
export const History = usesHtmlFile ? createHashHistory() : createBrowserHistory()
